module.exports = __webpack_public_path__ + "static/p_2-31491b1612e074bc154831954a5b214c.png";